import * as ACTION_TYPES from "./actionTypes";
// import _ from "lodash";
import { secure } from "./API/faiz";
import { FAIZ_ACCESS_TOKEN } from "../constants/staticKeys";
import { errorMessageHandle } from "../constants/utilities";
import { toast } from "react-toastify";

const { UPDATE_USER_PROPS, DELETE_USER_PROPS, MERGE_USER_PROPS } = ACTION_TYPES;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const updateUserProp = (prop, value) => {
  return { type: UPDATE_USER_PROPS, payload: [{ prop, value }] };
};
export const updateUserProps = (payload) => {
  return { type: UPDATE_USER_PROPS, payload: payload };
};
export const mergeUserProps = (payload) => {
  return { type: MERGE_USER_PROPS, payload: payload };
};
export const deleteUserProp = (prop) => {
  return { type: DELETE_USER_PROPS, payload: [{ prop }] };
};
export const deleteUserProps = (payload) => {
  return { type: DELETE_USER_PROPS, payload };
};

export const getUsers = (prop, page, param) => async (dispatch) => {
  let url = "/user?page=" + page;
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_USER_PROPS,
    payload: [{ prop: "isUsersLoading", value: true }],
  });
  secure(token)
    .get(url, { params: param })
    .then((response) => {
      dispatch({
        type: UPDATE_USER_PROPS,
        payload: [{ prop, value: response.data.users }],
      });
    })
    .catch((error) => {
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_USER_PROPS,
        payload: [{ prop: "isUsersLoading", value: false }],
      });
    });
};
const validateUsers = (users) => {
  let isValid = true;
  for (let i = 0; i < users.length; i++) {
    let message = "";
    if (users[i].name === "") {
      message = message + "User name is mandatory. ";
      isValid = false;
    }
    if (users[i].its === "") {
      message = message + "ITS is mandatory. ";
      isValid = false;
    }
    if (users[i].email === "") {
      message = message + "Email is mandatory. ";
      isValid = false;
    }
    if (!EMAIL_REGEX.test(users[i].email)) {
      message = message + "Email format invalid. ";
      isValid = false;
    }
    if (users[i].its.length !== 8) {
      message = message + "ITS is invalid. ";
      isValid = false;
    }
    if (message !== "") {
      message = message + "Check row " + (i + 1);
      toast.error(message);
    }
  }
  return isValid;
};
export const saveUsers = (users) => async (dispatch) => {
  let editedUsers = users.data.filter((v) => {
    return v.edited === true;
  });
  if (editedUsers.length === 0) {
  } else if (validateUsers(editedUsers)) {
    let url = "/user";
    let param = { users: editedUsers };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_USER_PROPS,
      payload: [{ prop: "isUserSaving", value: true }],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: UPDATE_USER_PROPS,
          payload: [{ prop: "isUsersTableEditable", value: false }],
        });
        for (let i = 0; i < users.length; i++) {
          dispatch({
            type: DELETE_USER_PROPS,
            payload: [{ prop: "users.data." + i + ".edited" }],
          });
        }
        toast.success(response.data.msg);
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_USER_PROPS,
          payload: [{ prop: "isUserSaving", value: false }],
        });
      });
  } else {
    dispatch({ type: "" });
  }
};

export const deleteUser = (user, index) => async (dispatch) => {
  if (user.hasOwnProperty("id")) {
    let url = "/user";
    let param = { users: [user.id] };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_USER_PROPS,
      payload: [{ prop: "users.data." + index + ".isDeleting", value: true }],
    });
    secure(token)
      .delete(url, { data: param })
      .then((response) => {
        dispatch({
          type: DELETE_USER_PROPS,
          payload: [{ prop: "users.data." + index }],
        });
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_USER_PROPS,
          payload: [
            { prop: "users.data." + index + ".isDeleting", value: false },
          ],
        });
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      });
  } else {
    dispatch({
      type: DELETE_USER_PROPS,
      payload: [{ prop: "users.data." + index }],
    });
  }
};

export const createUsers = (users) => async (dispatch) => {
  if (users.length === 0) {
    toast.error("No users to create");
  } else if (validateUsers(users)) {
    let url = "/user";
    let param = { users: users };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);

    dispatch({
      type: UPDATE_USER_PROPS,
      payload: [{ prop: "isUserCreating", value: true }],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: UPDATE_USER_PROPS,
          payload: [
            { prop: "isNewUserModalOpen", value: false },
            { prop: "newUsers", value: [] },
          ],
        });
        dispatch({
          type: MERGE_USER_PROPS,
          payload: [{ prop: "users.data", value: response.data.users }],
        });
        toast.success(response.data.msg);
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_USER_PROPS,
          payload: [{ prop: "isUserCreating", value: false }],
        });
      });
  } else {
    dispatch({ type: "" });
  }
};

export const changeUserPassword = (userId, password, passwordConfirmation) => async () => {
  const token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);

  return secure(token)
    .post("/user/password", {
      user_id: userId,
      password,
      password_confirmation: passwordConfirmation,
    })
    .then((response) => {
      toast.success(response.data.msg);
      return response;
    })
    .catch((error) => {
      toast.error(errorMessageHandle(error));
      throw error;
    });
};
